module.exports = __webpack_public_path__ + "d9b943476b0117986b7de34ac5e035c6.svg";